import moment from 'moment';

export default (timeText, time, no_text = false) => {
  return (no_text ? `` : `${timeText}:`) +  ` ${ moment(time).utc().format('DD-MM-YYYY HH:mm:ss') } UTC`;
}